// --
import React from 'react';
import classNames from 'classnames';
import AbstractReactComponent from "../AbstractReactComponent";

import "./DetailLeftIcon.scss";

/**
 * Komponenta, která obaluje obsah, který má vlevo na deailku velikou ikonu, slouží i pro ostatní řádky pod, které nemají ikonu, ale mají být správně odsazené.
 */
class DetailLeftIcon extends AbstractReactComponent {
    static propTypes = {
        icon: React.PropTypes.element, // blok s ikonami
        children: React.PropTypes.node, // blok s obsahem
        leftClassName: React.PropTypes.string,  // class pro levou část s ikonou
        rightClassName: React.PropTypes.string, // class pro pravOu část s obsahem
    };

    render() {
        const {icon, children, className, leftClassName, rightClassName, ...other} = this.props;

        const wrapperClassNames = classNames(
            "detail-left-icon-container",
            className
        );
        const leftClassNames = classNames(
            "detail-left-icon",
            leftClassName
        );
        const rightClassNames = classNames(
            "detail-left-content",
            rightClassName
        );

        return <div className={wrapperClassNames} {...other}>
            <div className={leftClassNames}>{icon}</div>
            <div className={rightClassNames}>{children}</div>
        </div>
    }
}

export default DetailLeftIcon;
